const { user_roles, user_org_roles } = require('Data/Enum');

// Site Title Configuration
const SITE_TITLE = 'HSC BOS';
const SITE_ICON = 'cube';
const APP_NAME = 'Budget and Ordering System';
const APP_DESCRIPTION = '';

const ALL_BOS_ROLES = [
  ...Object.values(user_roles),
  ...Object.values(user_org_roles).map((role) => ['*', role.key]),
];

// ----------------------------------------------------------------------------------------
// ------------------------------- NAVIGATION ---------------------------------------------
// ----------------------------------------------------------------------------------------
let NAVIGATION = {};

// Navigation details for app pages. Used for menus and breadcrumbs.
const SITE_PAGES = {
  HOME: {
    title: 'Home',
    text: 'Home',
    href: '#/',
    to: '/',
    icon: 'home',
    tabId: 'home',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  DASHBOARD: {
    title: 'Dashboard',
    text: 'Dashboard',
    href: '#/dashboard',
    to: '/dashboard',
    icon: 'control',
    tabId: 'dashboard',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  ORDER_LANDING: {
    title: 'Orders',
    text: 'Orders',
    href: '#/orders',
    to: '/orders/',
    icon: 'th',
    tabId: 'orders',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  NEW_ORDER: {
    title: 'New Order',
    text: 'New',
    href: '#/orders/new',
    to: '/orders/new',
    icon: 'insert',
    tabId: 'order-new',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  MY_ORDERS: {
    title: 'My Orders',
    text: 'My Orders',
    href: '#/orders/mine',
    to: '/orders/mine',
    icon: 'list-columns',
    tabId: 'order-list',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  ALL_ORDERS: {
    title: 'All Orders',
    text: 'All Orders',
    href: '#/orders/all',
    to: '/orders/all',
    icon: 'list-columns',
    tabId: 'order-list',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  REQUEST_ORDERS: {
    title: 'Requested Orders',
    text: 'Requested Orders',
    href: '#/orders/requests',
    to: '/orders/requests',
    icon: 'list-detail-view',
    tabId: 'req-order-list',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.ADMINISTRATIVE_APPROVER,
        user_roles.BUYER,
        user_roles.TRANSACTOR,
      ],
    },
  },
  ORDER_DETAIL: {
    title: 'Details',
    text: 'Details',
    to: '/orders/all',
    href: '#/orders/all',
    icon: 'heat-grid',
    tabId: 'order-detail',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  TRANSACTION_LANDING: {
    title: 'Transactions',
    text: 'Transactions',
    href: '#/transactions',
    to: '/transactions/',
    icon: 'dollar',
    tabId: 'trans',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUYER,
        user_roles.TRANSACTOR,
        ['*', user_org_roles.MANAGER],
      ],
    },
  },
  NEW_TRANSACTION: {
    title: 'New Transaction',
    text: 'New',
    href: '#/transactions/new',
    to: '/transactions/new',
    icon: 'insert',
    tabId: 'trans-new',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUYER,
        user_roles.TRANSACTOR,
      ],
    },
  },
  ALL_TRANSACTIONS: {
    title: 'All Transactions',
    text: 'All Transactions',
    href: '#/transactions/all',
    to: '/transactions/all',
    icon: 'list-columns',
    tabId: 'trans-list',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUYER,
        user_roles.TRANSACTOR,
        ['*', user_org_roles.MANAGER],
      ],
    },
  },
  TRANSACTION_DETAIL: {
    title: 'Details',
    text: 'Details',
    href: '#/transactions/all/:id',
    to: '/transactions/all',
    icon: 'heat-grid',
    tabId: 'trans-detail',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUYER,
        user_roles.TRANSACTOR,
        ['*', user_org_roles.MANAGER],
      ],
    },
  },
  RECONCILE: {
    title: 'Reconcile',
    text: 'Reconcile',
    href: '#/transactions/reconcile',
    to: '/transactions/reconcile',
    icon: 'merge-columns',
    tabId: 'trans-reconcile',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, user_roles.RECONCILER],
    },
  },
  TRANS_REVIEW: {
    title: 'Review',
    text: 'Review',
    href: '#/transactions/review',
    to: '/transactions/review',
    icon: 'form',
    tabId: 'trans-review',
    requiredAuth: {
      roles: [user_roles.TRANS_IMPORTER],
    },
  },
  ACCOUNT_LANDING: {
    title: 'Accounts',
    text: 'Manage Accounts',
    href: '#/account-management',
    to: '/account-management/',
    icon: 'projects',
    tabId: 'accounts',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUDGETER,
        ['*', user_org_roles.MANAGER.key],
      ],
    },
  },
  ABR_CODE: {
    title: 'ABR Codes',
    text: 'ABR Codes',
    href: '#/account-management/abr_codes',
    to: '/account-management/abr_codes',
    icon: 'diagram-tree',
    tabId: 'account-abr',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, user_roles.BUDGETER],
    },
  },
  EXPENSE_CODE: {
    title: 'Expense Codes',
    text: 'Expense Codes',
    href: '#/account-management/expense_codes',
    to: '/account-management/expense_codes',
    icon: 'briefcase',
    tabId: 'account-ec',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, user_roles.BUDGETER],
    },
  },
  ALL_ACCOUNTS: {
    title: 'All Accounts',
    text: 'All Accounts',
    href: '#/account-management/accounts/',
    to: '/account-management/accounts',
    icon: 'credit-card',
    tabId: 'account-config',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUDGETER,
        ['*', user_org_roles.MANAGER.key],
      ],
    },
  },
  BUDGETS: {
    title: 'Budgets',
    text: 'Budgets',
    href: '#/account-management/budgets',
    to: '/account-management/budgets',
    icon: 'bank-account',
    tabId: 'account-budget',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUDGETER,
        ['*', user_org_roles.MANAGER.key],
      ],
    },
  },
  ADMIN_LANDING: {
    title: 'Administration',
    text: 'Admin',
    href: '#/admin',
    to: '/admin/',
    icon: 'wrench',
    tabId: 'admin',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.PERMISSIONS_ADMINISTRATOR,
        user_roles.VENDOR_ADMINISTRATOR,
        ['*', user_org_roles.MANAGER.key],
      ],
    },
  },
  MANAGE_USERS: {
    title: 'Users',
    text: 'Users',
    href: '#/admin/users',
    to: '/admin/users',
    icon: 'people',
    tabId: 'admin-users',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, user_roles.PERMISSIONS_ADMINISTRATOR],
    },
  },
  MANAGE_FACILITIES: {
    title: 'Core Facilities',
    text: 'Core Facilities',
    href: '#/admin/facilities',
    to: '/admin/facilities',
    icon: 'office',
    tabId: 'admin-facilities',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, ['*', user_org_roles.MANAGER.key]],
    },
  },
  MANAGE_VENDORS: {
    title: 'Vendors',
    text: 'Vendors',
    href: '#/admin/vendors',
    to: '/admin/vendors',
    icon: 'shop',
    tabId: 'admin-vendors',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.BUYER,
        user_roles.VENDOR_ADMINISTRATOR,
      ],
    },
  },
  REPORTS: {
    title: 'Reports',
    text: 'Reports',
    href: '#/transactions/reports',
    to: '/transactions/reports',
    icon: 'chart',
    tabId: 're',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.REPORT_ACCESSOR,
        ['*', user_org_roles.MANAGER.key],
      ],
    },
  },
  SERVICE_CONTRACT_LANDING: {
    title: 'Service Contracts',
    text: 'Service Contracts',
    href: '#/service_contracts',
    to: '/service_contracts/',
    icon: 'remove-row-bottom', //'manual', //'book'
    tabId: 'sc_admin',
    requiredAuth: {
      roles: [user_roles.SC_ADMIN, ['*', user_org_roles.MANAGER]],
    },
  },
  ALL_SERVICE_CONTRACTS: {
    title: 'All Contracts',
    text: 'All Contracts',
    href: '#/service_contracts/contracts',
    to: '/service_contracts/contracts',
    icon: 'list',
    tabId: 'sc_admin',
    requiredAuth: {
      roles: [user_roles.SC_ADMIN],
    },
  },
  SC_DETAILS: {
    title: 'Details',
    text: 'Details',
    href: '#/service_contracts/contracts/:id',
    to: '/service_contracts/contracts',
    icon: 'git-repo', //'manually-entered-data',
    tabId: 'sc-detail',
    requiredAuth: {
      roles: [user_roles.SC_ADMIN],
    },
  },
  ALL_RESOURCES: {
    title: 'Resources / Assets',
    text: 'Resources/Assets',
    href: '#/service_contracts/resources',
    to: '/service_contracts/resources/',
    icon: 'multi-select',
    tabId: 'resource-list',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR, user_roles.SC_ADMIN],
    },
  },
  RESOURCE_DETAILS: {
    title: 'Details',
    text: 'Details',
    href: '#/service_contracts/resources/:id',
    to: '/service_contracts/resources',
    icon: 'label',
    tabId: 'resource-detail',
    requiredAuth: {
      roles: [
        user_roles.ADMINISTRATOR,
        user_roles.SC_ADMIN,
        ['*', user_org_roles.MANAGER],
      ],
    },
  },
  MY_ACCOUNT: {
    title: '',
    text: 'My Profile',
    href: '#/my_account',
    to: '/my_account',
    icon: 'user',
    tabId: 'my_account',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  CONFIG: {
    title: '',
    text: 'Settings',
    href: '#/configuration',
    to: '/configuration',
    icon: 'cog',
    tabId: 'configuration',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  HELP: {
    title: '',
    text: 'Help',
    href: '#/help',
    to: '/help',
    icon: 'help',
    tabId: 'help',
    requiredAuth: {
      roles: ALL_BOS_ROLES,
    },
  },
  ACCESS_DENIED: {
    to: '/access_denied',
  },
  LOG_IN: {
    title: 'Log In',
    icon: 'log-in',
    href: '#/login',
    to: '/login',
  },
  LOG_OUT: {
    text: 'Log Out',
    icon: 'log-out',
    href: '#/logout',
    to: '/logout',
  },
};

// UPPER NAV BAR
// Main Links
NAVIGATION.navbarLinks = [
  SITE_PAGES.NEW_ORDER,
  SITE_PAGES.REQUEST_ORDERS,
  SITE_PAGES.REPORTS,
];
// Right menu items
NAVIGATION.navbarRightLinks_LoggedIn = [
  {
    title: '',
    href: '',
    icon: 'chevron-down',
    menuItems: [SITE_PAGES.MY_ACCOUNT, SITE_PAGES.LOG_OUT],
  },
];

NAVIGATION.userAccountLinks = [SITE_PAGES.MY_ACCOUNT, SITE_PAGES.LOG_OUT];

NAVIGATION.navbarRightLinks_LoggedOut = [SITE_PAGES.LOG_IN];

// SIDE NAVIGATION. (Items can have a sub-menu defined by 'menuItems'.)
// Links for upper side navigation menu.
NAVIGATION.sideNavbarLinks = [
  // SITE_PAGES.DASHBOARD,
  {
    ...SITE_PAGES.ORDER_LANDING,
    menuItems: [
      SITE_PAGES.NEW_ORDER,
      SITE_PAGES.REQUEST_ORDERS,
      { ...SITE_PAGES.ALL_ORDERS, redirect: SITE_PAGES.MY_ORDERS },
    ],
  },
  {
    ...SITE_PAGES.TRANSACTION_LANDING,
    menuItems: [
      SITE_PAGES.NEW_TRANSACTION,
      SITE_PAGES.ALL_TRANSACTIONS,
      SITE_PAGES.RECONCILE,
      SITE_PAGES.TRANS_REVIEW,
      SITE_PAGES.REPORTS,
    ],
  },
  {
    ...SITE_PAGES.ACCOUNT_LANDING,
    menuItems: [
      SITE_PAGES.ALL_ACCOUNTS,
      SITE_PAGES.ABR_CODE,
      SITE_PAGES.EXPENSE_CODE,
      SITE_PAGES.BUDGETS,
    ],
  },
  {
    ...SITE_PAGES.ADMIN_LANDING,
    menuItems: [
      SITE_PAGES.MANAGE_USERS,
      SITE_PAGES.MANAGE_FACILITIES,
      SITE_PAGES.MANAGE_VENDORS,
    ],
  },
  {
    ...SITE_PAGES.SERVICE_CONTRACT_LANDING,
    menuItems: [SITE_PAGES.ALL_SERVICE_CONTRACTS, SITE_PAGES.ALL_RESOURCES],
  },
];

// Links for lower side navigation menu.
NAVIGATION.lowerSideNavbarLinks = [SITE_PAGES.CONFIG];

NAVIGATION.homePageLinks = [
  // SITE_PAGES.DASHBOARD,
  SITE_PAGES.NEW_ORDER,
  SITE_PAGES.ORDER_LANDING,
  SITE_PAGES.REPORTS,
  SITE_PAGES.CONFIG,
  SITE_PAGES.LOG_OUT,
  {
    ...SITE_PAGES.ADMIN_LANDING,
    menuItems: [
      SITE_PAGES.MANAGE_USERS,
      SITE_PAGES.MANAGE_FACILITIES,
      SITE_PAGES.MANAGE_VENDORS,
      SITE_PAGES.SERVICE_CONTRACT_LANDING,
    ],
  },
  {
    ...SITE_PAGES.TRANSACTION_LANDING,
    menuItems: [
      SITE_PAGES.NEW_TRANSACTION,
      SITE_PAGES.ALL_TRANSACTIONS,
      SITE_PAGES.RECONCILE,
    ],
  },
  {
    ...SITE_PAGES.ACCOUNT_LANDING,
    menuItems: [
      SITE_PAGES.ALL_ACCOUNTS,
      SITE_PAGES.ABR_CODE,
      SITE_PAGES.EXPENSE_CODE,
      SITE_PAGES.BUDGETS,
    ],
  },
];

NAVIGATION.homePageExternalLinks = [
  { title: 'HSC Cores Website', url: 'https://cores.utah.edu', icon: 'share' },
  {
    title: 'Resource System',
    url: 'https://resource.cores.utah.edu/',
    icon: 'open-application',
  },
];

const HELP_URL =
  'https://bookstack.cores.utah.edu/shelves/budget-and-ordering-system';
const HELP_EMAIL = 'megan.bowler@utah.edu,u0346559@utah.edu';
const ADMIN_EMAIL = 'billing@cores.utah.edu';

// ----------------------------------------------------------------------------------------
// ------------------------------- END NAVIGATION -----------------------------------------
// ----------------------------------------------------------------------------------------

module.exports = {
  SITE_TITLE,
  SITE_ICON,
  APP_NAME,
  APP_DESCRIPTION,
  SITE_PAGES,
  NAVIGATION,
  HELP_URL,
  HELP_EMAIL,
  ADMIN_EMAIL,
};
